// Cisco's product APIs return some product names with the spaces removed
// (CiscoNexus5596UPSwitch). The managed product keeps that name, because
// Prevent queries Cisco's bug API with it; only what the portal shows is
// spaced (Cisco Nexus 5596UP Switch).
//
// A word, or a run of three or more capitals, is split from the digits after
// it (Nexus 9000, ASR 1006); short model codes stay whole (VG350, 9410R).
const spaceCiscoName = name =>
  name
    .replace(/(?<=[a-z])(?=[A-Z])/g, ' ')
    .replace(/(?<=[a-z])(?=\d)|(?<=[A-Z]{3})(?=\d)/g, ' ')
    .replace(/(?<=\d)(?=[A-Z][a-z])/g, ' ')
    .replace(/(?<=[A-Z])(?=[A-Z][a-z])/g, ' ');

export const productDisplayName = (vendorId, name) => {
  if (vendorId !== 'cisco' || !name || name.includes(' ')) return name;
  return spaceCiscoName(name);
};
